import { ptBR } from './locales/pt-BR.js';
import { enUS } from './locales/en-US.js';
export const resources = {
    'pt-BR': {
        translation: ptBR,
    },
    'en-US': {
        translation: enUS,
    },
};
export { ptBR, enUS };
//# sourceMappingURL=index.js.map